export { default as Img200 } from './processed/200/Place-To-Call-Home-A-S6.jpg';
export { default as Img400 } from './processed/400/Place-To-Call-Home-A-S6.jpg';
export { default as Imgthumb } from './processed/thumb/Place-To-Call-Home-A-S6.jpg';
export { default as ImgthumbBlurSmall } from './processed/thumbBlurSmall/Place-To-Call-Home-A-S6.jpg';
export { default as ImgthumbBlurLarge } from './processed/thumbBlurLarge/Place-To-Call-Home-A-S6.jpg';
export const ImgData = { width: 1240, height: 720, ratio: 0.5806451612903226, orientation: 'landscape' };
export const colors = {
  "Vibrant": {
    "_rgb": [
      220,
      146,
      98
    ],
    "_population": 2167,
    "_hsl": [
      0.06557377049180325,
      0.6354166666666667,
      0.6235294117647059
    ]
  },
  "LightVibrant": {
    "_rgb": [
      244,
      188,
      147
    ],
    "_population": 800,
    "_hsl": [
      0.07044673539518903,
      0.8151260504201684,
      0.7666666666666666
    ]
  },
  "DarkVibrant": {
    "_rgb": [
      78,
      41,
      28
    ],
    "_population": 209,
    "_hsl": [
      0.043333333333333335,
      0.47169811320754723,
      0.20784313725490197
    ]
  },
  "Muted": {
    "_rgb": [
      156,
      116,
      88
    ],
    "_population": 850,
    "_hsl": [
      0.06862745098039215,
      0.27868852459016397,
      0.47843137254901963
    ]
  },
  "LightMuted": {
    "_rgb": [
      204,
      178,
      164
    ],
    "_population": 31,
    "_hsl": [
      0.058333333333333244,
      0.2816901408450705,
      0.7215686274509805
    ]
  },
  "DarkMuted": {
    "_rgb": [
      131,
      100,
      78
    ],
    "_population": 30,
    "_hsl": [
      0.06918238993710692,
      0.2535885167464114,
      0.40980392156862744
    ]
  }
}


// WEBPACK FOOTER //
// ./src/content/images/Place-To-Call-Home-A-S6.js